module.exports = __webpack_public_path__ + "img/il2.6eef508b.png";